import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { searchIconCss } from 'src/components/searchBox/SearchBoxStyle';
import { NewIconsSet } from 'src/utils/constants/IconsConstants';

import { colors } from '../../../../styles/colors';
import {
  ZeeFontBold,
  ZeeFontRegular,
  getNewIcons
} from '../../../../styles/font';
import { MediaBP as MQ } from '../../../../styles/mediaQuery';

export const container = css`
  z-index: 0;
  height: 100%;
  &:hover {
    z-index: 10;
  }
`;
export const contentItemPopUp = css`
  position: absolute;
  bottom: 0;
  padding: 10px 1px 5px 4px;
  background-color: ${colors.white};
  width: 100%;
  color: ${colors.black};
  opacity: 0;
  filter: blur(20px);
  text-align: left;
  transform: scale3d(0.01, 0.01, 0) translateZ(0) perspective(500px);
  transition: opacity 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), transform 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), filter 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
    background-color 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
    border-radius 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
  & h3 {
    font-size: 10px;
    font-weight: 700;
    line-height: 1.4em;
    ${ZeeFontBold(10, 20)}
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    color: ${colors.AccentDarkGrayColor};
  }
`;

export const contentItemCard = (showHover = false) => css`
  position: relative;
  width: 100%;
  height: 100%;
  &:after {
    content: '';
    position: absolute;
    border-radius: 12px;
    border: 0 solid ${colors.white};
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    z-index: -1;
  }
  img {
    border: 1px solid rgba(255, 255, 255, 0.32);
  }
  ${MQ.MediaLg} {
    ${showHover
      ? ''
      : `&:hover {
      transition: all;
      transform: scale3d(1.01, 1.01, 1) translateZ(0) perspective(500px);
      transition: transform 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
      transition-delay: 0.4s;
      z-index: 100;
      &:after {
        border: 8px solid ${colors.white};
        transition: border 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
        transition-delay: 0.4s;
        bottom: -7px;
        left: -7px;
        right: -7px;
        top: -7px;
      }
      & footer {
        transition-delay: 0.4s;
        opacity: 0;
        h3 {
          transition-delay: 0.4s;
        }
      }
      figure {
        img {
          transform: scale(1);
          transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          transition-delay: 0.4s;
        }
      }
      .popup-content {
        opacity: 1;
        transform: scaleX(1) translateZ(0) perspective(0);
        transition: opacity 0.25s ease-in,
          bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
          transform 0.25s ease-in,
          bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
          filter 0.25s ease-in,
          bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
          background-color 0.25s ease-in,
          bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
          border-radius 0.25s ease-in,
          bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
        transition-delay: 0.4s;
        filter: inherit;
        z-index: 2;
      }
    }`}
  }
`;

export const thumbnailTitleWrapper = (showTitleWithinThumbnail = false) => css`
  ${ZeeFontRegular(14, 20)};
  font-weight: 700;
  padding-top: 8px;
  display: -webkit-box;
  display: box;
  max-height: 48px;
  white-space: wrap;
  -webkit-line-clamp: 2;
  /* autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  overflow: hidden;
  text-overflow: ellipsis;

  ${showTitleWithinThumbnail
    ? `
      z-index: 1;
      left: 9px;
      right: 9px;
      position: relative;
      bottom: 9px;
      width: 85%;
    `
    : ``}
`;
export const thumbnailTitleDate = css`
  color: ${colors.white};
`;
export const thumbnailTitle = (showTitleWithinThumbnail = false) => css`
  color: ${colors.greyText};
  ${showTitleWithinThumbnail
    ? `
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      display: block;
    `
    : ``}
`;

export const iconCss = css`
  padding-right: 5px;
  ${getNewIcons(NewIconsSet.SEARCH)};
  font-size: 20px;
`;

export const SearchIconCss = styled.div`
  ${getNewIcons(NewIconsSet.SEARCH)};
  font-size: 22px;
  ${MQ.MediaXl} {
    font-size: 24px;
  }
  ${searchIconCss};
`;
